<template>
  <v-card flat>
    <v-card-title>Via från station</v-card-title>
    <v-card-text>
      <v-row>
        <v-col>
          <v-autocomplete
            :items="placesMap"
            item-value="location_name"
            :item-text="item => `(${item.short_name}) ${item.stop_name}`"
            :filter="
              (item, query) =>
                item.short_name.toLowerCase().includes(query.toLowerCase()) ||
                item.stop_name.toLowerCase().includes(query.toLowerCase())
            "
            outlined
            :item-disabled="
              item => order.some(x => x.location_name === item.location_name)
            "
            label="Via från"
            v-model="model.via_from_location"
            @change="onAddLocation"
          >
          </v-autocomplete>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <v-card>
            <v-card-title class="text-overline"
              >Geografisk ordning</v-card-title
            >
            <v-divider></v-divider>
            <v-list flat>
              <v-list-item v-for="(item, i) in order" :key="i">
                <v-btn
                  icon
                  small
                  color="error"
                  class="mr-4"
                  @click="onRemoveLocation(item)"
                >
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.stop_name"
                  ></v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    :disabled="i === 0"
                    icon
                    small
                    @click="onChangeOrder(item, i - 1)"
                  >
                    <v-icon small>mdi-chevron-up</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action>
                  <v-btn
                    :disabled="i === order.length - 1"
                    icon
                    small
                    @click="onChangeOrder(item, i + 2)"
                  >
                    <v-icon small>mdi-chevron-down</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
        <v-col>
          <v-card>
            <v-card-title class="text-overline">Prioritering</v-card-title>
            <v-divider></v-divider>
            <v-list flat>
              <v-list-item v-for="(item, i) in priority" :key="i">
                <v-list-item-content>
                  <v-list-item-title
                    v-text="item.stop_name"
                  ></v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-btn
                    :disabled="i === 0"
                    icon
                    small
                    @click="onChangePriority(item, i - 1)"
                  >
                    <v-icon small>mdi-chevron-up</v-icon>
                  </v-btn>
                </v-list-item-action>
                <v-list-item-action>
                  <v-btn
                    :disabled="i === order.length - 1"
                    icon
                    small
                    @click="onChangePriority(item, i + 2)"
                  >
                    <v-icon small>mdi-chevron-down</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>
          </v-card>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { get } from 'vuex-pathify'
import gql from 'graphql-tag'
import orderBy from 'lodash.orderby'

export default {
  name: 'DuwaViaFrom',

  props: {
    codes: {
      type: Array,
      default: () => []
    }
  },

  apollo: {
    stops: {
      query: gql`
        query stops {
          stops {
            stop_name
            short_name
          }
        }
      `,

      fetchPolicy: 'no-cache'
    }
  },

  data: () => ({
    model: {
      via_from_location: null
    },
    order: [],
    priority: []
  }),

  created() {
    const mapData = type =>
      orderBy(
        this.$store.get('duwa/currentViaFromLocation'),
        [type],
        ['asc']
      ).map(x => {
        return {
          ...(this.stops.find(
            y => y.short_name.toLowerCase() === x.location_name.toLowerCase()
          ) || {}),
          location_name: x.location_name
        }
      })
    this.order = mapData('order')
    this.priority = mapData('priority')
  },

  watch: {
    order(value) {
      this.$store.set(
        'duwa/payload',
        this.payload.map(x => ({
          ...x,
          viafromlocation: {
            ...x.viafromlocation,
            after: this.transformPayload(value)
          }
        }))
      )
    },

    priority() {
      this.$store.set(
        'duwa/payload',
        this.payload.map(x => ({
          ...x,
          viafromlocation: {
            ...x.viafromlocation,
            after: this.transformPayload(this.order)
          }
        }))
      )
    }
  },

  computed: {
    payload: get('duwa/payload'),
    stops: get('duwa/stops'),
    places: get('duwa/places'),
    placesMap() {
      return this.places.map(x => {
        return {
          ...((this.stops || []).find(
            y => y.short_name.toLowerCase() === x.toLowerCase()
          ) || {}),
          location_name: x
        }
      })
    }
  },

  methods: {
    transformPayload(value) {
      return value.map((x, i) => {
        return {
          location_name: x.location_name,
          order: i,
          priority:
            this.priority.findIndex(y => y.location_name === x.location_name) +
            1
        }
      })
    },

    onAddLocation(location) {
      const item = {
        ...this.placesMap.find(x => x.location_name === location)
      }

      this.order.push(item)
      this.priority.push(item)

      this.$nextTick(() => {
        this.model.via_from_location = null
      })
    },

    onRemoveLocation(_item) {
      const item = {
        ..._item
      }
      this.order = this.order.filter(
        x => x.location_name !== item.location_name
      )
      this.priority = this.priority.filter(
        x => x.location_name !== item.location_name
      )
    },

    onChangeOrder(_item, index) {
      const item = {
        ..._item
      }
      this.order = [
        ...this.order
          .slice(0, index)
          .filter(x => x.location_name !== item.location_name),
        item,
        ...this.order
          .slice(index)
          .filter(x => x.location_name !== item.location_name)
      ]
    },

    onChangePriority(_item, index) {
      const item = {
        ..._item
      }
      this.priority = [
        ...this.priority
          .slice(0, index)
          .filter(x => x.location_name !== item.location_name),
        item,
        ...this.priority
          .slice(index)
          .filter(x => x.location_name !== item.location_name)
      ]
    }
  }
}
</script>
